import './Button.css';

// Reusable brand button. Variants: primary (lit lime), ghost, danger.
// `small` tightens padding/size. `style` and other props pass straight through.
export default function Button({
  children, variant = 'primary', small = false,
  disabled = false, style, className = '', ...rest
}) {
  const classes = [
    'gw-btn',
    `gw-btn--${variant}`,
    small ? 'gw-btn--sm' : '',
    className,
  ].filter(Boolean).join(' ');

  return (
    <button className={classes} disabled={disabled} style={style} {...rest}>
      {children}
    </button>
  );
}
